<span class="badge regiao-situacao-badge"
    [class.regiao-situacao-ativa]="config?.isAtiva"
    [class.regiao-situacao-inativa]="config?.isInativa"
    [style.fontSize]="fontSize">
    {{situacao | regiaoSituacao }}
</span>